import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectCurrentProfileId } from '../../../../accounts/selectors/profile-id.selector.ts';
import { RootState } from '../../../../main/store/main.store.ts';
import { LessonTaskStepKey } from '../../../../main/types/asset/lesson.types.ts';
import { getSentryUtil } from '../../../../main/utils/monitoring/sentry.util.ts';

import { ProgressErrors } from '../../../constants/errors.ts';
import { completeStepMutationRequest } from '../../../requests/complete-step.mutation.ts';
import { selectIsUsingTempTracking } from '../../../selectors/is-using-temp-tracking.selector.ts';

import { PROGRESS_SLICE_NAME } from '../progress.slice.types.ts';

export const syncLastCompletedStepThunk = createAsyncThunk(
  `${PROGRESS_SLICE_NAME}/syncLastCompletedStepThunk`,
  async (stepKey: LessonTaskStepKey, thunkApi): Promise<boolean> => {
    const state = thunkApi.getState() as RootState;
    const isUsingTempTracking = selectIsUsingTempTracking(state);

    if (isUsingTempTracking) {
      return false;
    }

    const currentProfileId = selectCurrentProfileId(state);

    if (!currentProfileId) {
      getSentryUtil().trackError(new Error(ProgressErrors.NO_CURRENT_PROFILE), {});
      return false;
    }

    const response = await completeStepMutationRequest({
      profileId: currentProfileId,
      lesson: stepKey.lesson,
      task: stepKey.task,
      step: stepKey.step,
    });

    return response.success;
  }
);
